module.exports = __webpack_public_path__ + "img/contrology-classical@1x.8dd3fb1b.png";